import React from 'react';
import { withStyles, FormControl, Typography, InputLabel, OutlinedInput, IconButton, Tooltip } from '@material-ui/core';
import { Info } from "@material-ui/icons";
import clsx from "clsx";
import { workIcon, workVerifierIcon, workDiagnoseIcon, workCheckIcon, mobileIcon, mobileVerifierIcon, mobileDiagnoseIcon, mobileCheckIcon, remoteIcon, moneyIcon, mobileErasureLiteIcon, watchIcon, watchDiagnoseIcon, watchCheckIcon, headphoneDiagnoseIcon, headphoneCheckIcon } from '../utils';

const styles = theme => ({
    root: {
        paddingBottom: theme.spacing(3),
        margin: '0, auto',
        display: 'inline-flex',
        flexDirection: 'row',
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1)
    },
    withoutLabel: {
        marginTop: theme.spacing(3)
    },
    textField: {
        width: "15%",
        margin: '0, auto'
    },
    span: {
        position: 'relative',
        display: 'row',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0, auto',
        width: 'auto',
    },
    typo: {
        position: 'relative',
        display: 'inline',
        padding: theme.spacing(2),
    },
    typo2: {
        position: 'relative',
        display: 'inline',
        padding: theme.spacing(2),
        marginLeft: '24rem'
    },
    btn: {
        width: '98%',
        marginLeft: '0.5rem',
        marginRight: '0.5rem'
    },
    title: {
        alignItems: 'left',
        justifyContent: 'left',
        textAlign: 'left',
        fontSize: '150%',
        position: 'relative',
        display: 'flex',
        padding: theme.spacing(2),
    },
    to: {
        backgroundColor: 'rgb(232,232,232)'
    },
    submit: {
        width: '120px',
        marginTop: '10px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    icon: {
        color: 'rgb(220,220,220)',
    },
    unitName: {
        paddingTop: '1rem',
        width: '22rem',
    },
});

const TopUpUnit = props => {
    const {
        classes,
        values,
        translations,
        errors,
        touched,
        name,
        setValues,
        topupPriceList
    } = props;

    const priceListUnitNameMapping = {
        'Work Erasure': 'work',
        'Work Erasure Verification': 'work_verifier',
        'Work Diagnose': 'work_diagnose',
        'Work Check': 'work_check',
        'Mobile Erasure': 'mobile',
        'Mobile Erasure Lite': 'mobile_erasure_lite',
        'Mobile Erasure Verification': 'mobile_verifier',
        'Mobile Diagnose': 'mobile_diagnose',
        'Mobile Check': 'mobile_check',
        'Watch Erasure': 'watch',
        'Watch Diagnose': 'watch_diagnose',
        'Watch Check': 'watch_check',
        'Headphone Diagnose': 'headphone_diagnose',
        'Headphone Check': 'headphone_check',
        Remote: 'remote',
        Currency: 'currency',
    };

    let unitName =  priceListUnitNameMapping[name];

    const icon = name === "Remote" ? remoteIcon : name === "Mobile Erasure" ? mobileIcon : name === "Mobile Erasure Lite" ? mobileErasureLiteIcon : name === "Mobile Diagnose" ? mobileDiagnoseIcon : name === "Mobile Check" ? mobileCheckIcon : name === "Work Diagnose" ? workDiagnoseIcon : name === "Work Erasure" ? workIcon : name === "Work Check" ? workCheckIcon : name === "Work Erasure Verification" ? workVerifierIcon : name === "Mobile Erasure Verification" ? mobileVerifierIcon : name === "Currency" ? moneyIcon : name === "Watch Erasure" ? watchIcon : name === "Watch Diagnose" ? watchDiagnoseIcon : name === "Watch Check" ? watchCheckIcon : name === "Headphone Diagnose" ? headphoneDiagnoseIcon : name === "Headphone Check" ? headphoneCheckIcon : null

    const tooltip = <Typography className={classes.tooltip} variant="subtitle1">{topupPriceList && (topupPriceList[unitName] || []).map((el, index) => <span key={el.to + index}>{translations['from'] || 'From'}{':'} {el.from}, {translations['to'] || 'To'}{':'} {el.to || <>&#8734;</>} , {translations['price'] || 'Price'}{':'} {el.price}<br></br></span>)}</Typography>

    const calculateValues = (amountValue) => {
        const priceListForType = topupPriceList?.[unitName];
        const priceObject = priceListForType.find(
            (el, index) =>
                (Math.abs(amountValue) >= el.from && (priceListForType[index+1] ? Math.abs(amountValue) < priceListForType[index+1].from : true))
        )

        if (priceObject) {
            setValues({ ...values, [name]: { amount: amountValue, price: priceObject.price ?? 0, total: amountValue * priceObject.price ?? 0 } })
        } else if (!priceObject) {
            setValues({ ...values, [name]: { amount: amountValue, price: null, total: null } })
        }
        if (amountValue === 0 || amountValue === "") {
            setValues({ ...values, [name]: { amount: 0, price: 0, total: 0 } })
        }
    }

    const blockInvalidChar = (e) => name === "Currency" ? ['e', 'E', '+'].includes(e.key) && e.preventDefault() : ['e', 'E', '+', '.'].includes(e.key) && e.preventDefault();

    const showTooltip = topupPriceList && topupPriceList[unitName]?.length > 0;

    return (
        <div className={classes.root}>
            <div className={classes.row}>
                <Typography variant="h6" className={classes.unitName}>
                    {icon} {name === "Currency"? translations["money"] || "Money" : translations[name?.toLowerCase()?.replaceAll(' ', '_')] || name}
                    {
                        showTooltip &&
                        <Tooltip title={tooltip}>
                            <IconButton aria-haspopup="true" color="inherit">
                                <Info className={classes.icon} />
                            </IconButton>
                        </Tooltip>
                    }
                </Typography>
                <FormControl
                    className={clsx(classes.margin, classes.textField)}
                    variant="outlined"
                >
                    <InputLabel htmlFor="amount">{translations['amount'] || 'Amount'}</InputLabel>
                    <OutlinedInput
                        name={`${name}.amount`}
                        label={translations['amount'] || 'Amount'}
                        type="number"
                        onKeyDown={(e) => {blockInvalidChar(e);}}
                        value={values[name]?.amount || ''}
                        onChange={(e) => {calculateValues(Number(e.target.value))}}
                        error={!!(errors[name]?.amount && touched[name]?.amount)}
                        className={!showTooltip? classes.to : ""}
                        inputProps={{
                            step: name==="Currency"? ".01" : "any",
                            readOnly: !showTooltip,
                            autoComplete: 'new-password',
                            form: {
                            autoComplete: 'off',
                            },
                        }}
                        labelWidth={0}
                    />
                </FormControl>
                <span className={classes.span}>x</span>
                <FormControl
                    className={clsx(classes.margin, classes.textField)}
                    variant="outlined"
                >
                    <InputLabel htmlFor="price">{translations['price'] || 'Price'}</InputLabel>
                    <OutlinedInput
                        className={classes.to}
                        name={`${name}.price`}
                        type="number"
                        label={translations['price'] || 'Price'}
                        value={values[name]?.price || ''}
                        contentEditable={false}
                        inputProps={{
                            readOnly: true,
                        }}
                        labelWidth={0}
                    />
                </FormControl>
                <span className={classes.span}>=</span>
                <FormControl
                    className={clsx(classes.margin, classes.textField)}
                    variant="outlined"
                >
                    <InputLabel htmlFor="total">{translations['total'] || 'Total'}</InputLabel>
                    <OutlinedInput
                        className={classes.to}
                        name={`${name}.total`}
                        type={'number'}
                        label={translations['total'] || 'Total'}
                        value={values[name]?.total || ''}
                        contentEditable={false}
                        inputProps={{
                            readOnly: true,
                            "aria-label": "to"
                        }}
                        labelWidth={0}
                    />
                </FormControl>
            </div>
        </div>)
};

export default withStyles(styles, { withTheme: true })(TopUpUnit);